module.exports = __webpack_public_path__ + "static/media/app-bar-logo.f45c26b9.svg";